module.exports = __webpack_public_path__ + "static/media/dualJuniorActive.699cb858.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/dualJuniorActive.png
// module id = 595
// module chunks = 0